<template>
  <table class="table table-responsive table-bordered">
    <tbody>
      <tr>
        <td
          v-for="job in novice_job"
          :key="job.id"
          class="text-center"
          colspan="13"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <tr>
        <td
          v-for="job in first_job"
          :key="job.id"
          class="text-center"
          :colspan="[job.colspan ? job.colspan : 2]"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <tr>
        <td
          v-for="job in second_job"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <tr>
        <td
          v-for="job in transcendence_job"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <tr>
        <td
          v-for="job in third_job"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <tr>
        <td
          v-for="job in fourth_job"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            :class="jobImageClass(job.id)"
          />
        </td>
      </tr>
      <!-- First row with Taekwon and Ninja -->
      <tr>
        <!-- First column: Taekwon job (spanning 2 cells) -->
        <td 
          class="text-center"
          colspan="2"
          :class="{'job-selected': parseInt(4046) == $store.state.character.job}"
        >
          <img
            :id="4046"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4046.png'), delay: 250 }"
            :alt="'Taekwon'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Third column: Ninja (spans 2 cells so Kagerou + Oboro both fit under it) -->
        <td
          v-for="job in expanded_first_job.filter(j => j.id === 25)"
          :key="job.id"
          class="text-center"
          colspan="2"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Gunslinger -->
        <td
          v-for="job in expanded_first_job.filter(j => j.id === 24)"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Super Novice -->
        <td
          v-for="job in expanded_first_job.filter(j => j.id === 23)"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job,
            'gender-specific': isGenderSpecificJob(job.id)
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Summoner (Doram) -->
        <td
          v-for="job in expanded_first_job.filter(j => j.id === 4218)"
          :key="job.id"
          class="text-center"
          :class="{
            'job-selected': parseInt(job.id) == $store.state.character.job
          }"
        >
          <img
            :id="job.id"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_' + job.id + '.png'), delay: 250 }"
            :alt="job.name"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>
      <!-- Second row for Star Gladiator and Soul Linker under Taekwon -->
      <tr>
        <!-- Star Gladiator (under Taekwon) -->
        <td class="text-center" :class="{'job-selected': parseInt(4047) == $store.state.character.job}">
          <img
            :id="4047"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4047.png'), delay: 250 }"
            :alt="'Star Gladiator'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Soul Linker (under Taekwon) -->
        <td class="text-center" :class="{'job-selected': parseInt(4049) == $store.state.character.job}">
          <img
            :id="4049"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4049.png'), delay: 250 }"
            :alt="'Soul Linker'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
        
        <!-- Empty cells under Ninja (colspan=2), Gunslinger, Super Novice -->
        <td colspan="2"></td>
        <td></td>
        <td></td>
      </tr>

      <!-- Third row: 4th-class extensions of the expanded jobs -->
      <tr>
        <!-- Mestre Estelar (Star Emperor) — under Star Gladiator → under Taekwon col 1 -->
        <td class="text-center" :class="{'job-selected': parseInt(4239) == $store.state.character.job}">
          <img
            :id="4239"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4239.png'), delay: 250 }"
            :alt="'Star Emperor'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>

        <!-- Ceifador de Alma (Soul Reaper) — under Soul Linker → under Taekwon col 2 -->
        <td class="text-center" :class="{'job-selected': parseInt(4240) == $store.state.character.job}">
          <img
            :id="4240"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4240.png'), delay: 250 }"
            :alt="'Soul Reaper'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>

        <!-- Kagerou — left half of the Ninja column (which spans 2 cells) -->
        <td class="text-center" :class="{'job-selected': parseInt(4211) == $store.state.character.job, 'gender-specific': isGenderSpecificJob(4211)}">
          <img
            :id="4211"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4211.png'), delay: 250 }"
            :alt="'Kagerou'"
            @click="clickJob($event)"
            :class="jobImageClass(4211)"
          />
        </td>

        <!-- Oboro — right half of the Ninja column, next to Kagerou -->
        <td class="text-center" :class="{'job-selected': parseInt(4212) == $store.state.character.job, 'gender-specific': isGenderSpecificJob(4212)}">
          <img
            :id="4212"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4212.png'), delay: 250 }"
            :alt="'Oboro'"
            @click="clickJob($event)"
            :class="jobImageClass(4212)"
          />
        </td>

        <!-- Insurgente (Rebellion) — under Justiceiro (Gunslinger) -->
        <td class="text-center" :class="{'job-selected': parseInt(4215) == $store.state.character.job}">
          <img
            :id="4215"
            v-lazy="{ src: require('../../assets/img/job/icon_jobs_4215.png'), delay: 250 }"
            :alt="'Rebellion'"
            @click="clickJob($event)"
            class="job-image"
          />
        </td>
      </tr>

      <!-- Fourth row: expanded 4th classes (primary can't render them, routed to iRO Wiki) -->
      <tr>
        <!-- Mestre Celestial (Sky Emperor) — under Mestre Estelar -->
        <td class="text-center" :class="{'job-selected': parseInt(4302) == $store.state.character.job}">
          <img :id="4302" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4302.png'), delay: 250 }" :alt="'Mestre Celestial'" @click="clickJob($event)" class="job-image" />
        </td>
        <!-- Asceta (Soul Ascetic) — under Ceifador de Alma -->
        <td class="text-center" :class="{'job-selected': parseInt(4303) == $store.state.character.job}">
          <img :id="4303" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4303.png'), delay: 250 }" :alt="'Asceta'" @click="clickJob($event)" class="job-image" />
        </td>
        <!-- Shinkiro (male, Kagerou line) -->
        <td class="text-center" :class="{'job-selected': parseInt(4304) == $store.state.character.job, 'gender-specific': isGenderSpecificJob(4304)}">
          <img :id="4304" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4304.png'), delay: 250 }" :alt="'Shinkiro'" @click="clickJob($event)" :class="jobImageClass(4304)" />
        </td>
        <!-- Shiranui (female, Oboro line) -->
        <td class="text-center" :class="{'job-selected': parseInt(4305) == $store.state.character.job, 'gender-specific': isGenderSpecificJob(4305)}">
          <img :id="4305" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4305.png'), delay: 250 }" :alt="'Shiranui'" @click="clickJob($event)" :class="jobImageClass(4305)" />
        </td>
        <!-- Guerrilheiro (Night Watch) — under Insurgente -->
        <td class="text-center" :class="{'job-selected': parseInt(4306) == $store.state.character.job}">
          <img :id="4306" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4306.png'), delay: 250 }" :alt="'Guerrilheiro'" @click="clickJob($event)" class="job-image" />
        </td>
        <!-- Hiperaprendiz (Hyper Novice) -->
        <td class="text-center" :class="{'job-selected': parseInt(4307) == $store.state.character.job}">
          <img :id="4307" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4307.png'), delay: 250 }" :alt="'Hiperaprendiz'" @click="clickJob($event)" class="job-image" />
        </td>
        <!-- Animista (Spirit Handler) — Doram -->
        <td class="text-center" :class="{'job-selected': parseInt(4308) == $store.state.character.job}">
          <img :id="4308" v-lazy="{ src: require('../../assets/img/job/icon_jobs_4308.png'), delay: 250 }" :alt="'Animista'" @click="clickJob($event)" class="job-image" />
        </td>
      </tr>

    </tbody>
  </table>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      novice_job: [
        {
          id: 0,
          name: "Novice",
        },
      ],
      first_job: [
        {
          id: 1,
          name: "Swordman",
        },
        {
          id: 2,
          name: "Magician",
        },
        {
          id: 3,
          name: "Archer",
          colspan: 3,
        },
        {
          id: 4,
          name: "Acolyte",
        },
        {
          id: 5,
          name: "Merchant",
        },
        {
          id: 6,
          name: "Thief",
        },
      ],
      second_job: [
        {
          id: 7,
          name: "Knight",
        },
        {
          id: 14,
          name: "Crusader",
        },
        {
          id: 9,
          name: "Wizard",
        },
        {
          id: 16,
          name: "Sage",
        },
        {
          id: 11,
          name: "Hunter",
        },
        {
          id: 19,
          name: "Bard",
        },
        {
          id: 20,
          name: "Dancer",
        },
        {
          id: 8,
          name: "Priest",
        },
        {
          id: 15,
          name: "Monk",
        },
        {
          id: 10,
          name: "Blacksmith",
        },
        {
          id: 18,
          name: "Alchemist",
        },
        {
          id: 12,
          name: "Assassin",
        },
        {
          id: 17,
          name: "Rogue",
        },
      ],
      transcendence_job: [
        {
          id: 4008,
          name: "Lord Knight",
        },
        {
          id: 4015,
          name: "Paladin",
        },
        {
          id: 4010,
          name: "High Wizard",
        },
        {
          id: 4017,
          name: "Professor",
        },
        {
          id: 4012,
          name: "Sniper",
        },
        {
          id: 4020,
          name: "Clown",
        },
        {
          id: 4021,
          name: "Gypsy",
        },
        {
          id: 4009,
          name: "High Priest",
        },
        {
          id: 4016,
          name: "Champion",
        },
        {
          id: 4011,
          name: "Whitesmith",
        },
        {
          id: 4019,
          name: "Creator",
        },
        {
          id: 4013,
          name: "Assassin Cross",
        },
        {
          id: 4018,
          name: "Stalker",
        },
      ],
      third_job: [
        {
          id: 4060,
          name: "Rune Knight",
        },
        {
          id: 4066,
          name: "Royal Guard",
        },
        {
          id: 4061,
          name: "Warlock",
        },
        {
          id: 4067,
          name: "Sorcerer",
        },
        {
          id: 4062,
          name: "Ranger",
        },
        {
          id: 4068,
          name: "Minstrel",
        },
        {
          id: 4069,
          name: "Wanderer",
        },
        {
          id: 4063,
          name: "Arch Bishop",
        },
        {
          id: 4070,
          name: "Sura",
        },
        {
          id: 4064,
          name: "Mechanic",
        },

        {
          id: 4071,
          name: "Genetic",
        },
        {
          id: 4065,
          name: "Guillotine Cross",
        },

        {
          id: 4072,
          name: "Shadow Chaser",
        },
      ],
      fourth_job: [
        {
          id: 4252,
          name: "Dragon Knight",
        },
        {
          id: 4258,
          name: "Imperial Guard",
        },
        {
          id: 4255,
          name: "Arch Mage",
        },
        {
          id: 4261,
          name: "Elemental Master",
        },
        {
          id: 4257,
          name: "Windhawk",
        },
        {
          id: 4263,
          name: "Troubadour",
        },
        {
          id: 4264,
          name: "Trouvere",
        },
        {
          id: 4256,
          name: "Cardinal",
        },
        {
          id: 4262,
          name: "Inquisitor",
        },
        {
          id: 4253,
          name: "Meister",
        },
        {
          id: 4259,
          name: "Biolo",
        },
        {
          id: 4254,
          name: "Shadow Cross",
        },
        {
          id: 4260,
          name: "Abyss Chaser",
        },
      ],
      expanded_first_job: [
        {
          id: 4046,
          name: "Taekwon",
        },
        {
          id: 25,
          name: "Ninja",
          colspan: 2,
        },
        {
          id: 24,
          name: "Gunslinger",
        },
        {
          id: 23,
          name: "Super Novice",
        },
        {
          id: 4218,
          name: "Summoner",
        },
      ],
      expanded_second_job: [
        {
          id: 4047,
          name: "Star Gladiator",
        },
        {
          id: 4049,
          name: "Soul Linker",
        },
      ],
      expanded_third_job: [
        {
          id: 4239,
          name: "Star Emperor",
        },
        {
          id: 4240,
          name: "Soul Reaper",
        },
        {
          id: 4211,
          name: "Kagerou",
        },
        {
          id: 4212,
          name: "Oboro",
        },
        {
          id: 4215,
          name: "Rebellion",
        },
        {
          id: 4190,
          name: "Ex. Super Novice",
        },
      ],
      expanded_fourth_job: [
        {
          id: 4302,
          name: "JT_SKY_EMPEROR",
        },
        {
          id: 4303,
          name: "JT_SOUL_ASCETIC",
        },
        {
          id: 4304,
          name: "JT_SHINKIRO",
        },
        {
          id: 4305,
          name: "JT_SHIRANUI",
        },
        {
          id: 4306,
          name: "JT_NIGHT_WATCH",
        },
        {
          id: 4307,
          name: "JT_HYPER_NOVICE",
        },
        {
          id: 4308,
          name: "JT_SPIRIT_HANDLER",
        },
        {
          id: 22,
          name: "Wedding",
        },
        {
          id: 26,
          name: "Christmas",
        },
        {
          id: 27,
          name: "Summer",
        },
        {
          id: 30,
          name: "Summer",
        },
        {
          id: 28,
          name: "Hanbok",
        },
        {
          id: 29,
          name: "Oktoberfest",
        },
      ],
      regular_mount_list: {
        7: 13,
        14: 21,
        4008: 4014,
        4015: 4022,
        4060: 4081,
        4073: 4083,
        4062: 4085,
        4064: 4087,
        4066: 4082,
        4257: 4278,
        4253: 4279,
        4252: 4280,
        4258: 4281,
      },
      cash_mount_list: {
        0: 4124,
        1: 4116,
        2: 4130,
        3: 4122,
        4: 4126,
        5: 4119,
        6: 4141,
        7: 4199,
        8: 4156,
        9: 4134,
        10: 4138,
        11: 4154,
        12: 4145,
        14: 4203,
        15: 4125,
        16: 4131,
        17: 4142,
        18: 4137,
        19: 4149,
        20: 4147,
        23: 4128,
        24: 4115,
        25: 4114,
        4001: 4183,
        4002: 4184,
        4003: 4185,
        4004: 4186,
        4005: 4187,
        4006: 4188,
        4007: 4189,
        4008: 4200,
        4009: 4157,
        4010: 4136,
        4011: 4118,
        4012: 4150,
        4013: 4146,
        4015: 4204,
        4016: 4139,
        4017: 4135,
        4018: 4144,
        4019: 4121,
        4020: 4153,
        4021: 4152,
        4023: 4158,
        4024: 4159,
        4025: 4160,
        4026: 4161,
        4027: 4162,
        4028: 4163,
        4029: 4181,
        4030: 4207,
        4031: 4194,
        4032: 4195,
        4033: 4196,
        4034: 4164,
        4035: 4165,
        4037: 4210,
        4038: 4166,
        4039: 4167,
        4040: 4168,
        4041: 4169,
        4042: 4170,
        4043: 4171,
        4045: 4172,
        4046: 4155,
        4047: 4123,
        4049: 4117,
        4054: 4202,
        4055: 4133,
        4056: 4198,
        4057: 4129,
        4058: 4197,
        4059: 4140,
        4060: 4202,
        4061: 4133,
        4062: 4198,
        4063: 4129,
        4064: 4197,
        4065: 4140,
        4066: 4201,
        4067: 4132,
        4068: 4148,
        4069: 4151,
        4070: 4127,
        4071: 4120,
        4072: 4143,
        4073: 4201,
        4074: 4132,
        4075: 4148,
        4076: 4151,
        4077: 4127,
        4078: 4120,
        4079: 4143,
        4096: 4209,
        4097: 4173,
        4098: 4206,
        4099: 4174,
        4100: 4205,
        4101: 4175,
        4102: 4208,
        4103: 4176,
        4104: 4177,
        4105: 4178,
        4106: 4179,
        4107: 4180,
        4108: 4182,
        4190: 4192,
        4191: 4193,
        4211: 4213,
        4212: 4214,
        4215: 4216,
        4218: 4219,
        4239: 4245,
        4240: 4246,
      },
    };
  },
  methods: {
    ...mapMutations(["SAVE_JOB"]),
    isGenderSpecificJob(job_id) {
      job_id = parseInt(job_id);
      const currentGender = this.$store.state.character.gender;
      
      // Male-only jobs (Bard, Clown, Minstrel, Kagerou, Troubadour, Shinkiro)
      const maleOnlyJobs = [19, 4020, 4068, 4211, 4263, 4304];

      // Female-only jobs (Dancer, Gypsy, Wanderer, Oboro, Trouvere, Shiranui)
      const femaleOnlyJobs = [20, 4021, 4069, 4212, 4264, 4305];
      
      // If male is selected (gender=1), female jobs should be disabled
      // If female is selected (gender=0), male jobs should be disabled
      if (currentGender === 1) {
        return femaleOnlyJobs.includes(job_id);
      } else {
        return maleOnlyJobs.includes(job_id);
      }
    },
    clickJob: function (event) {
      let job_id = parseInt(event.target.id);
      
      // Check if job is gender-specific and if it matches current gender
      if (this.isGenderSpecificJob(job_id)) {
        return; // Don't allow selection
      }
      
      if (this.$store.state.cash_mount_checked) {
        if (job_id in this.cash_mount_list) {
          job_id = this.cash_mount_list[job_id];
        }
      } else if (this.$store.state.regular_mount_checked) {
        if (job_id in this.regular_mount_list) {
          job_id = this.regular_mount_list[job_id];
        }
      }
      this.SAVE_JOB(job_id);
    },
  },
  computed: {
    jobImageClass() {
      return (jobId) => {
        return {
          'job-image': true,
          'disabled': this.isGenderSpecificJob(jobId)
        };
      };
    }
  },
  watch: {
    "$store.state.cash_mount_checked": {
      deep: true,
      handler(newValue, oldValue) {
        let current_job = this.$store.state.character.job[0];
        if (newValue == 1) {
          if (current_job in this.cash_mount_list) {
            this.SAVE_JOB(this.cash_mount_list[current_job]);
          }
        } else {
          Object.keys(this.cash_mount_list).forEach((key) => {
            if (this.cash_mount_list[key] == current_job) {
              this.SAVE_JOB(parseInt(key));
            }
          });
        }
      },
    },
    "$store.state.regular_mount_checked": {
      deep: true,
      handler(newValue, oldValue) {
        let current_job = this.$store.state.character.job[0];
        if (newValue == 1) {
          if (current_job in this.regular_mount_list) {
            this.SAVE_JOB(this.regular_mount_list[current_job]);
          }
        } else {
          Object.keys(this.regular_mount_list).forEach((key) => {
            if (this.regular_mount_list[key] == current_job) {
              this.SAVE_JOB(parseInt(key));
            }
          });
        }
      },
    },
    "$store.state.character.gender": {
      handler() {
        // Check if current job is gender-specific and reset if needed
        const currentJob = parseInt(this.$store.state.character.job[0]);
        if (this.isGenderSpecificJob(currentJob)) {
          // Reset to novice if current job is not valid for the new gender
          this.SAVE_JOB(0);
        }
        // Force re-render to update disabled states
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.job-selected {
  background-color: #0d6efd !important;
}

.job-image {
  align-self: flex-start;
}

@media (max-width: 991px) {
  .job-image {
    height: 18px;
  }
}

.table {
  margin-bottom: 0px !important;
}
.table > :not(caption) > * > * {
  padding: 1px;
}

.job-disabled {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.job-image.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.gender-specific {
  opacity: 0.4;
  cursor: not-allowed;
  position: relative;
  background-color: rgba(200, 200, 200, 0.3) !important;
}

.gender-specific img {
  filter: grayscale(100%);
  pointer-events: none;
}
</style>
